@if (notification && showErrorPanel) {
  <div class="quotes-notification">
    <div class="quotes-notification-header">Error Information</div>
    <div class="quotes-failure-panel" role="alert">
        @if (notification.response) {
          <p class="error-summary">{{ notification.response }}</p>
        } @else {
          <p class="error-summary">Quote processing failed.</p>
        }

        @if (failingItems.length > 0) {
          <div class="failing-items-section">
            <div class="failing-items-heading">Failing items</div>
            <ul class="failing-items-list">
              @for (item of failingItems; track item.stockCode) {
                <li class="failing-item">
                  <span class="stock-code">{{ item.stockCode }}</span>
                  <span class="item-desc">{{ item.desc }}</span>
                </li>
              }
            </ul>
            @for (guidance of itemErrorGuidance; track guidance.reason) {
              <p class="guidance-text">{{ guidance.guidance }}</p>
            }
          </div>
        }

<!--        @if (failureActions.length > 0) {-->
<!--          <div class="error-actions">-->
<!--            @for (action of failureActions; track action.action) {-->
<!--              <app-shared-button-->
<!--                [colour]="action.action === quoteFailureActions.viewError ? 'danger' : 'primary'"-->
<!--                [fill]="true"-->
<!--                (buttonClicked)="onFailureActionClick(action.action)">-->
<!--                {{ action.label }}-->
<!--              </app-shared-button>-->
<!--            }-->
<!--          </div>-->
<!--        }-->
    </div>
  </div>
}
